import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { UserService } from './services';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-route-refresh',
  template: '',
  styles: []
})

export class RouteRefreshComponent implements OnInit, OnDestroy {

  private subscription;

  constructor(
    private router: Router,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.subscription = this.userService.isAuthenticated
      .pipe(distinctUntilChanged())
      .subscribe(
        (isAuthenticated) => {
          if (isAuthenticated) {
            const currentUser = this.userService.getCurrentUser();

            // Sprawdź czy użytkownik ma tylko uprawnienie viewRecordings
            if (this.hasOnlyViewRecordingsPrivilege(currentUser)) {
              this.router.navigateByUrl('/caregivers/telecare');
            } else if (this.userService.getRole() === 1) {
              this.router.navigateByUrl('/users/user/' + currentUser.user_id.imei);
            } else if (this.userService.getRole() === 2) {
              this.router.navigateByUrl('/caregivers/alarms');
            } else if (this.userService.getRole() === 3) {
              this.router.navigateByUrl('/caregivers');
            }
          } else {
            this.router.navigateByUrl('auth/login');
          }
        }
      );
  }

  private hasOnlyViewRecordingsPrivilege(user: any): boolean {
    if (!user || !user.user_id || !user.user_id.privilege) {
      return false;
    }
    const privileges = user.user_id.privilege.split(';').map(p => p.trim());
    return privileges.includes('viewRecordings') && privileges.length === 1;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/route-refresh.component.ts